module.exports = __webpack_public_path__ + "static/devboard-7490ed9eab4bc66f914b9ebfbddef86e.png";